@use "foundation/_colors.scss";

.title-editor textarea {
  background: transparent;
  color: colors.$ifttt-next-dark-bg-text-color !important;
  font-weight: 700;
  margin: 0;
  font-size: 2em;
  line-height: 1.15;

  &.dynamic {
    width: 66%;
  }

  border: 4px solid rgba(255, 255, 255, 0.3) !important;

  padding: 0.5em;
}

.edit-details {
  display: flex;
  justify-content: space-between;

  font-size: 16px;

  .name-length {
    color: rgba(255, 255, 255, 0.55);
  }

  button {
    font-size: 16px;
    font-weight: 700;
    color: colors.$ifttt-next-dark-bg-text-color;
    text-decoration: underline;
    cursor: pointer;

    &:disabled {
      cursor: default;
      color: rgba(255, 255, 255, 0.55);
    }
  }
}

.connection-title {
  display: block;
  &.editable {
    cursor: pointer;
  }
  &.editing {
    display: none;
  }
}
